import { render, staticRenderFns } from "./materialSelect.vue?vue&type=template&id=094081d2&"
import script from "./materialSelect.vue?vue&type=script&lang=js&"
export * from "./materialSelect.vue?vue&type=script&lang=js&"
import style0 from "./materialSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports